import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
    dateFormatter,
    buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { getSubPlans, deleteSubPlan } from "../../../../api/subPlan";
import { getNonEmpty } from '../../../../utils/helpers';


export default function SubPlanPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [data, setData] = useState([]);
    const [subPlan, setSubPlan] = useState(null);


    function buttonFormatter(cell) {
        const elem = data.find((item) => item._id === cell);
        return (
            <>
                <Tooltip title="Edit">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => history.push("/edit-subscriptionPlan/" + elem._id)}
                    >
                        <EditIcon />
                    </Button>
                </Tooltip>
                {user?.role === "admin" && (
                    <>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setSubPlan(elem);
                                    setOpenConfirmDialog(2);
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
            </>
        );
    }

    const priceFormatter = (cell) => { // TODO: REVISAR
        return (
            <div style={{ textAlign: 'right', width: '30%' }}>
                {cell != null ? `${cell} €` : '-'}
            </div>
        );
    };

    const columns = [
        { dataField: "title", text: "Title", sort: true },
        { dataField: "target", text: "Target audience", sort: true },
        { dataField: "monthPrice", text: "Monthly price", sort: true, formatter: priceFormatter },
        { dataField: "yearPrice", text: "Annual price", sort: true, formatter: priceFormatter },
        {
            dataField: "createdAt",
            text: "Fecha de creación",
            formatter: dateFormatter,
            sort: true,
        },
        {
            dataField: "_id",
            text: "",
            formatter: buttonFormatter
        },
    ];

    useEffect(() => {
        getSubPlans()
            .then((res) => {
                const data = res.data.map(item => ({
                    ...item,
                    title: getNonEmpty(item.title),
                    target: item.target.charAt(0).toUpperCase() + item.target.slice(1).toLowerCase()
                }))
                setData(data);
            })
            .catch((error) => {
                alertError({ error: error, customMessage: "Could not get subscription plans" });
            });
    }, [refresh]);

    return (
        <>
            <Card>
                <CardHeader title="Subscription plans list">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-primary text-white"
                            onClick={() => history.push("/edit-subscriptionPlan")}
                        >
                            Add new
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <Table search={true} data={data} columns={columns} />
                    <ConfirmDialog
                        title={"Are you sure you want to delete this subscription plan?"}
                        open={openConfirmDialog === 2}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteSubPlan(subPlan._id)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Subscription plan deleted successfully.",
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the subscription plan.",
                                    });
                                });
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}
